import { AVRProducts } from '@/utils/enums';

export default store => {
  store.subscribe(async (mutation, state) => {
    if (mutation.type === 'business/SET_INFO') {
      const mutationPayload = mutation.payload;
      const { products } = mutationPayload;

      if (products.includes(AVRProducts.SPIN)) {
        if (state.route.query.vin) {
          try {
            await store.dispatch('spin/setSpinSettings', state.route.query.vin);
          } catch (error) {
            store.commit('business/HIDE_PRODUCT', { products: [AVRProducts.SPIN] }, { root: true });
            store.commit('spin/SET_SPIN_ERROR', true);
          }
        } else {
          // if we don't have a vin we want to hide spin
          store.commit('business/HIDE_PRODUCT', { products: [AVRProducts.SPIN] }, { root: true });
          store.commit('spin/SET_SPIN_ERROR', true);
        }
      }
    }
  });
};
